<template>
	<div class="createpage" >
		<!-- v-loading="isloading" -->
		<div class="detail_head FlexBetween">
			<div class="head_left Flexalign">
				<div class="return_btn FlexRow"  @click="returnpage">
					<i class="el-icon-back"></i>
					<span>
						返回
					</span>
				</div>
				<div class="title">
					{{detail_title}}
				</div>
			</div>
			
			<div class="head_right Flexalign">
				<div class="customBtn FlexRow" @click="Preserve">
					保存
				</div>
				<div class="customBtn FlexRow style2" @click="returnpage">
					取消
				</div>
				
			</div>
		</div>
		<!--  -->
		
		<div class="detail_templates" v-for="(item1, index1) in ClassInitial">
			<div class="detail_intitle Flexalign">
				{{item1.name || ''}}
			</div>
			
			<template v-if="item1.name == '产品信息'">
				
				<productinfor ref="productiref"  :flag.sync="serveFlag"
				:goodslist="order_goods"
				@fnexport="productexport" :fieldlist="ProductInfoField"
				@satisfy="fnSatisfy"
				@completeset="completeset"
				></productinfor>
			</template>
			
			<template v-else-if="item1.name == '基本信息'">
				<fieldshow :types="item1.type" :fieldlist="essentialInfo"></fieldshow>
			</template>
			
			<template v-else-if="item1.name == '费用及收款'">
				<div class="receipts_box FlexBetween">
					<div class="receipts_item Flexalign">
						<div class="tit">
							整单折扣额(￥)：
						</div>
						<el-input
						:disabled="order_price == '0.00'"
						@change="discountChange($event, 1)"
						 :oninput="oninput"
						v-model="discount_amount"
						  placeholder="请输入内容"
						  clearable>
						</el-input>
					</div>
					<div class="receipts_item Flexalign">
						<div class="tit">
							整单折扣率(%)：
						</div>
						<el-input
						:disabled="order_price == '0.00'"
						@change="discountChange($event, 2)"
						 :oninput="oninput"
						v-model="discount_rate" 
						  placeholder="请输入内容"
						  clearable>
						</el-input>
					</div>
					<div class="receipts_item Flexalign">
						<div class="tit">
							订单金额：￥{{order_price}}
						</div>
						
					</div>
				</div>
			</template>
			
			<template v-else-if="item1.name == '回款信息'">
				<div id="returnid">
					<collectioninfor  ref="collecti" :flag.sync="serveFlag"
					:returnid="returnid"  @satisfy="fnReturnSatisfy"
					@fnexport="collectexport" :fieldlist="CollectionInfoField" ></collectioninfor>
				</div>
				
			</template>
			<!-- @returnfile="returnfile" -->
			<template v-else-if="item1.name == '附件信息'">
				<enclofile  ref="upfile" 
				
				@setupfile="fnsetfile" @fndelet="fndelet" :enclist.sync="enclist"></enclofile>
			</template>
			
			<template v-else>
				<fieldshow :types="item1.type" :fieldlist="FieldInitial"></fieldshow>
			</template>
			
			
		</div>
		
		
	</div>
</template>

<script>
	import {
		handlereq,
		retujudpower,
		retupower,
		alertMess,
		retfieldPower,
		fn_fielddisabled ,
		fnCustomPage,
		exportExcel,

		
		bytesToSize,
		getFileType_,
		clickgate,
		getMumberUser,
	} from 'network/kh_public'
	import {
		fn_newfield,
		ToggleTime,
		setupfile,
		getCurrentTime,
	} from 'network/hk_operset'
	 
	import {
		// 订单字段分类 
		get_order_group_list, 
		// 订单字段
		get_order_field_list,
		// 订单状态
		get_order_status_list,
		
		add_order,
		
		
		edit_order,
		get_order_details ,
		get_order_compute,
		
	} from 'network/hk_order'

	
	
	import {
		get_quotation_details,
	} from 'network/hk_quotation'
	import productinfor from "../../components/productinfor.vue";
	import collectioninfor from "../components/detail/collectioninfor.vue";
	// 上传附件
	import enclofile from "../../components/enclofile.vue";
	import fieldshow from "../../components/fieldshow.vue";
	import {
		fn_retjson,
		retJSONArr,
		Basics_field,
		contrastDaily,
		fn_findeditid,
		formatCurrency,
	} from "network/defaults";
	export default {
		name: "orderdetail",
		components: {
			fieldshow,
			productinfor,
			collectioninfor,
			enclofile,
		},
		created() {
			
			// 获取跳转参数
			this.order_id = this.$route.query.order_id || 0;
			this.is_recycle = this.$route.query.is_recycle || 0;
			this.quotation_id = this.$route.query.quotation_id || 0;
			this.glopertype = this.$route.query.glopertype 
			if(this.order_id) {
				this.getDetails()
				this.isEdit = true
				this.detail_title = '编辑订单'
				this.is_return = this.$route.query.is_return || false;
			}
			else if(this.quotation_id) {
				this.getDetails()
				this.isEdit = true
				this.detail_title = '转为订单'
			}
			else {
				this.fn_get_orderStatu(1)
			}
			// 
			this.fn_cleardatas()
		},
		watch: {
			
		},
		methods:{
			//获取成员列表
			getMumberList() {
				getMumberUser().then((res) => {
					if (res.code == 1000) {
						let obj = res.result || [];
						for (let item of obj) {
							item.id = item.member_id
						}
						this.memberlist = obj
					}
				});
			},
			fn_cleardatas(){
				this.editfieldlist = []
				this.field_initial = []
				this.dailyRecord = []
				this.getMumberList()
			},
			// 删除 附件 图片
			fndelet(e) {  
				let {index ,id} = e
				this.enclist.splice(index, 1)
			},
			
			// 获取订单详情
			getDetails() {
				if(this.order_id) {
					get_order_details(this.order_id).then(res => {
						if (!this.$handlereq(res)) return
						let obj = res.result || '';
						if (!obj) return;
						// 字段信息
						let parse_info = retJSONArr(obj.order_info)
						this.editfieldlist = fn_retjson(parse_info)
						
						this.handle_data(obj, true)
						this.isloading = false
						this.fn_get_orderStatu(2)
					})
				}
				else if(this.quotation_id) {
					get_quotation_details(this.quotation_id).then(res => {
						if (!this.$handlereq(res)) return
						let obj = res.result || '';
						if (!obj) return;
						// 字段信息
						let parse_info = retJSONArr(obj.order_info)
						this.editfieldlist = fn_retjson(parse_info)
						
						this.handle_data(obj)
						this.isloading = false
						this.fn_get_orderStatu(2)
					})
				}
			},
			findJsonInfo(field_sign) {
				let res = '';
				let index1 = this.order_info.findIndex(v => v.field_sign == field_sign)
				if (index1 != -1 && this.order_info[index1]) {
					res = this.order_info[index1].content || '';
				}
				return res;
			},
			
			handle_data(obj, flag) {
				// 订单字段详情， 产品信息， 回款信息
				let {
					discount_amount,
					discount_rate,
				} = obj
				
				
				// 费用及收款
				if(discount_amount) {
					this.currentInput = 1
					this.discount_amount = discount_amount || '';
				}
				else if(discount_rate) {
					this.currentInput = 2
					this.discount_rate = discount_rate || '';
				}
				
				if(flag) {  //订单 详情
					if (obj.order_info && typeof(obj.order_info) === 'string') {
						let Json_Obj = JSON.parse(obj.order_info)
						this.order_info = Json_Obj
						
						obj.address = ''
						obj.address_txt = ''
						let content = this.findJsonInfo('收货地址')
						if(content) {
							obj.address = content
							obj.address_txt = `${content.area_txt1 || ''}${content.area_txt2 || ''}${content.area_txt3 || ''}${content.address || ''}`
						}
						obj.remarks = this.findJsonInfo('订单备注') || ''
						this.enclist = this.findJsonInfo('上传附件') || []
					}
					this.satisfy_goods = obj.order_goods || ''
					
				}
				else {  // 报价单转订单
					if (obj.quotation_info && typeof(obj.quotation_info) === 'string') {
						let Json_Obj = JSON.parse(obj.quotation_info)
						this.order_info = Json_Obj
						obj.address = ''
						obj.address_txt = ''
						let content = this.findJsonInfo('收货地址')
						if(content) {
							obj.address = content
							obj.address_txt = `${content.area_txt1 || ''}${content.area_txt2 || ''}${content.area_txt3 || ''}${content.address || ''}`
						}
						obj.remarks = this.findJsonInfo('报价单备注')
						this.enclist = this.findJsonInfo('上传附件') || []
					}
					this.satisfy_goods = obj.quotation_goods || ''
					
				}
				// 协同人
				let textArr = []
				if (obj.assistant_member && obj.assistant_member.length) {
					for (let item of obj.assistant_member) {
						if (item.member_id) {
							textArr.push(item.member_id)
						}
					}
				}
				obj.assistant_arr = textArr
				this.DetailsData = JSON.parse(JSON.stringify(obj))
				if(discount_rate) {
					this.discount_rate = discount_rate
					this.discount_amount = ''
				}
				else if(discount_amount){
					this.discount_amount = discount_amount
					this.discount_rate = ''
				}
				// 回款相关显示
				if(obj.return_id) {
					this.returnid = obj.return_id || '';
					this.return_id = obj.return_id || '';
					this.satisfy_returnId = obj.return_id || '';
				}
			},
			fnSatisfy(e){
				if(e) {
					if(this.currentInput == 1) {
						this.discount_rate = ''
					}
					else if(this.currentInput == 2) {
						this.discount_amount = ''
					}
					this.satisfy_goods = e.order_goods
					this.setComputeSatisfy()
				}
			},
			fnReturnSatisfy(e){
				if(e) {
					this.satisfy_returnId = e.return_id
					this.setComputeSatisfy()
				}
			},
			discountChange(e, flag){
				if(flag == 1) {
					
					let num = parseInt(this.order_price)
					if(this.discount_amount < num) {
						this.discount_rate = ''
						this.setComputeSatisfy()
						this.currentInput = flag
					}
					else {
						alertMess('整单折扣额应小于订单金额', 'error')
					}
				}
				else if(flag == 2) {
					if(this.discount_rate <= 100) {
						this.discount_amount = ''
						this.setComputeSatisfy()
						this.currentInput = flag
					}
					else {
						alertMess('整单折扣率应为0~100', 'error')
					}
				}
			},
			
			completeset(){
				setTimeout(()=>{
					this.setComputeSatisfy()
				}, 500)
			},
			setComputeSatisfy(){
				let data = {
					order_goods: '',
				}
				if(this.satisfy_goods) {
					data.order_goods = this.satisfy_goods
					if(this.discount_amount) {
						data.discount_amount = this.discount_amount
					}
					if(this.discount_rate) {
						data.discount_rate = this.discount_rate
					}
					if(this.satisfy_returnId) {
						data.return_id = this.satisfy_returnId
					}
					this.getOrderCompute(data)
				}
			},
			// 获取订单计算数据
			getOrderCompute(Compute){
				let infoArrr = []
				
				for(let item of Compute.order_goods) {
					let newEle = {
						goods_num: item.goods_num,
						goods_price: item.goods_price,
						discount_rate: item.discount_rate,
						vat_rate: item.vat_rate,
					}
					infoArrr.push(newEle)
				}
				let fd = new FormData();
				fd.append('goods_info', JSON.stringify(infoArrr)) // 是	string	产品信息
				if(Compute.discount_amount) {
					fd.append('discount_amount', Compute.discount_amount) // 否	int	折扣额
				}
				if(Compute.discount_rate) {
					fd.append('discount_rate', Compute.discount_rate) //  	否	int	折扣率
				}
				if(Compute.return_id) {
					fd.append('return_id', Compute.return_id) // 	否	string	回款id
				}
				get_order_compute(fd).then(res=>{
					if(handlereq(res)) {
						let obj = res.result
						this.setderCompute(obj)
					}
				})
			},
			setderCompute(obj){
				if(this.$refs.productiref) {
					this.$refs.productiref[0].gnmentcompa(obj)
				}
				if(this.$refs.collecti) {
					this.$refs.collecti[0].gnmentcompa(obj)
				}
				this.order_price = obj.order_price || '0.00';
				if(obj.discount_rate != undefined) {
					this.discount_rate = obj.discount_rate
				}
				if(obj.discount_amount != undefined) {
					this.discount_amount = obj.discount_amount
				}
				
			},
			// -----------------------
			// 产品信息返回
			productexport(e){
		
				if(e) {
					let fieldarr = e.res
					// 产品id
					this.goods_id = e.goods_id || ''
					// 规格详情id
					this.details_id = e.details_id || ''
					// 产品信息复赋值 初始字段列表
					if(this.quotation_id) {
						this.productExportInfo = JSON.stringify(fieldarr)
					}
					else {
						if(this.isEdit) {
							this.judgeGoodSign(fieldarr)
						}
						else {
							this.productExportInfo = JSON.stringify(fieldarr)
						}
					}
					
					if(this.serveFlag) {
						this.fn_savefile()	
					}
				}
			},
			judgeGoodSign(arr) {
				let goods_info = {
					add_goods_info: [],
					edit_goods_info: [],
					del_goods_info: '', // og_id
				}
				let Sign = this.orderGoodSign
				// 新增的产品信息
				let add_arr = arr.filter(v=>!v.og_id)
				goods_info.add_goods_info = add_arr
				// 有记录的旧数据
				let ogArr = arr.filter(v=>v.og_id)
				// 删除的数据id
				let del_arr = []
				for(let value of Sign) {
					let index1 = ogArr.findIndex(v=>v.og_id == value.og_id)
					// 能否找到产品信息，检查是否有修改
					if(index1 != -1 && ogArr[index1]) {
						let curEl1 = JSON.stringify(ogArr[index1])
						let curEl2 = JSON.stringify(value)
						if(curEl1 != curEl2) {
							goods_info.edit_goods_info.push(ogArr[index1])
						}
					}
					else { // 有删除
						del_arr.push(value.og_id)
					}
				}
				goods_info.del_goods_info = del_arr.length ? del_arr.join(',') : '';
				this.productExportInfo = JSON.stringify(goods_info)
			},
			// 回款信息返回
			collectexport(e){
				
				if(e) {
					this.collectInfo = e.res
					this.assignment('回款编号', e.res)
				}
			},
			// 保存
			Preserve(){
				if(clickgate()) {
					if(this.$refs.productiref[0]) {  // 判断产品信息是否可以保存
						this.$refs.productiref[0].exportres()
					}
					if(this.$refs.collecti[0]) {  // 
						this.$refs.collecti[0].exportres()
					}
				}
			},
			// 附件信息 上传附件
			fnsetfile(e){
				if(e) {
					if(e.newArr) {
						this.enclist = this.enclist.concat(e.newArr);
					}
				}
			},
			fn_savefile(){
				this.fileuplen = 0
				let arr = this.enclist.filter(v=>v.raw)
				if(arr.length) {
					this.flielen = arr.length;
					for(let i =0; i< this.enclist.length; i++) {
						let item = this.enclist[i]
						if(item.raw) {
							this.fn_setupsfile(item, i)
							
						}
					}
				}
				else {
					this.assignment('上传附件', this.enclist)
					this.fn_clearCance()
					this.judgeEssen()
				}
			},
			fn_setupsfile(file, index) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let fd = new FormData()
				fd.append('store_id', this.$store.state.store_id)
				fd.append('file_name', file.name)
				fd.append('file[]', file.raw)			
				setupfile(fd).then(res => {
					let obj = res.result[0] // 返回的文件信息					
					if (!handlereq(res)) return
					let ele = {
						original_name: obj.original_name, //文件名
						path: obj.file_url || "", // 文件地址
						fileSize: bytesToSize(file.size), 
						member_name: this.$store.state.member_name,
						create_time: getCurrentTime(),
						file_type: obj.file_type,
					}
					if (obj.file_type == 0) {
						ele.imgSrc = obj.file_url // 文件图标
					} else {
						ele.imgSrc = getFileType_(obj) // 文件图标
					}
					this.enclist[index] = ele
					// 
					this.fileuplen += 1
					if (this.fileuplen == this.flielen) {
						this.fileuplen = 0
						this.flielen = 0
						
						this.assignment('上传附件', this.enclist)
						this.fn_clearCance()
						this.judgeEssen()
					}	
					loading.close();
				})
			},
			// 取消所有正在请求的接口
			fn_clearCance() {
				this.$store.commit('clearCancelToken')
			},
			// 判断基本信息是否可以保存
			judgeEssen(){
				let f_Arr = ['订单编号','订单日期','客户','联系人','订单状态','负责人']
				let flag = true
				for(let item of f_Arr) { 
					let res = this.findField_Essen(item)
					if(!res) {
						alertMess(`请正确编辑${item}`,'error')
						flag = false
						break;
					}
				}
				if(flag) {
					// 基本信息复赋值 初始字段列表
					for(let value of this.essentialInfo) {
						this.assignmid(value.field_id, value.content, value.field_type)
					}
					setTimeout(()=>{
						this.fn_addOrders()
					}, 500)
				}
			},
			// 查询基本字段列表
			findField_Essen(field_sign){
				let res = ''
				if (this.essentialInfo.length) {
					let index = this.essentialInfo.findIndex(v => v.field_sign == field_sign)
					if (index != -1 && this.essentialInfo[index]) {
						return this.essentialInfo[index].content
					} 
				}
				return res;
			},
			
			// 赋值 初始字段列表 
			assignment(field_sign, content, field_type){
				let index1 = this.FieldInitial.findIndex(v=>v.field_sign == field_sign)
				if(index1 != -1 && this.FieldInitial[index1]) {
					this.FieldInitial[index1].content = content
					if(field_type) {
						this.FieldInitial[index1].field_type = field_type   
					}
				}
			},
			assignmid(field_id, content, field_type){
				let index1 = this.FieldInitial.findIndex(v=>v.field_id == field_id)
				if(index1 != -1 && this.FieldInitial[index1]) {
					this.FieldInitial[index1].content = content
					if(field_type) {
						this.FieldInitial[index1].field_type = field_type   
					}
				}
			},
			// 添加订单  
			fn_addOrders(){
				// 基本信息里的必填字段
				let dd_code = this.findField_Essen('订单编号')
				let order_time = this.findField_Essen('订单日期')
				let customer_id = this.findField_Essen('客户')
				let contact_id = this.findField_Essen('联系人')
				let status_id = this.findField_Essen('订单状态')
				let member_id = this.findField_Essen('负责人')
				// 接口传参数据
				let fd = new FormData();
				fd.append('dd_code', dd_code) //是	string	订单编号
				fd.append('customer_id', customer_id) //是	int	客户id
				fd.append('contact_id', contact_id) //是	int	联系人id
				fd.append('status_id', status_id) // int	状态id
				fd.append('member_id', member_id) // 是	int	成员id
				fd.append('goods_id', this.goods_id) //是	string	商品id 逗号间隔末尾加逗号
				fd.append('goods_info', this.productExportInfo) //是	string	商品信息
				// 是	string	规格明细id 逗号间隔末尾加逗号
				fd.append('details_id', this.details_id)
					
				// 
				let len = (order_time + '').length
				let orderTime2 = len > 10 ? ((order_time + '').slice(0, 10) * 1) : order_time;
				fd.append('order_time', orderTime2) //是	int	订单时间
				// 
				if(this.currentInput == 1) {
					if(this.discount_amount) {
						this.assignment('整单折扣额', this.discount_amount)
						fd.append('discount_amount', this.discount_amount) //否	int	整单折扣额
					}
				}
				else if(this.currentInput == 2) {
					if(this.discount_rate) {
						this.assignment('整单折扣率', this.discount_rate)
						fd.append('discount_rate', this.discount_rate) //否	int	整单折扣率
					}
				}
				// 
				let assistant_member_id = this.findField_Essen('协同人') || [];
				if (assistant_member_id && assistant_member_id.length) { // 	否	string	协同人id	逗号间隔 加 逗号
					let assistant_res = assistant_member_id.join(',') + ','
					fd.append('assistant_member_id', assistant_res) 	//否	string	协助人
				}
				//  
				if(this.collectInfo) {
					fd.append('return_id', this.collectInfo) //否	string	回款id 逗号间隔加逗号
				}
				let newArr = Basics_field(this.FieldInitial)
				fd.append('order_info', JSON.stringify(newArr))  //是	string	订单信息
				
				
				if(this.order_id) {  // 订单id
					fd.append('order_id', this.order_id) //
				}
				if(this.isEdit) { // 编辑
					if(this.quotation_id){ // 报价单转订单
						add_order(fd).then(res=>{
							if (handlereq(res)) {
								alertMess('添加成功')
								this.returnpage()
							}
						})
					}
					else if(this.order_id){
						edit_order(fd).then(res=>{
							if (handlereq(res)) {
								alertMess('编辑成功')
								this.returnpage()
							}
						})
					}
				}
				else {  // 新建 
					add_order(fd).then(res=>{
						if (handlereq(res)) {
							alertMess('添加成功')
							this.returnpage()
						}
					})
				}
			},
			
			returnpage() {
				this.$router.go(-1)
			},
			
			// -----------------------
			// 获取订单状态
			fn_get_orderStatu(flag) {
				get_order_status_list().then(res => {
					if (!this.$handlereq(res)) return
					let obj = res.result.data
					for (let item of obj) {
						item.id = item.status_id
					}
					this.OrderStatus = obj
					// 获取字段分类
					this.getFieldClass(flag)
				})
			},
			// 获取字段分类
			getFieldClass(flag) {
				get_order_group_list(999, 1).then(res => {
					if (!this.$handlereq(res)) return
					let obj = res.result.data || []
					if(obj && obj.length) {
						for (let item of obj) {
							item.type = item.group_id
							item.fieldnewArr = []
						}
						this.ClassInitial = obj
						this.getConfigList(flag)
					}
				})
			},
			// 获取字段列表
			getConfigList(flag) {
				this.field_data = []
				get_order_field_list(999,1).then(res => {
					if (!this.$handlereq(res)) return
					let list = res.result.data || [];
					this.field_initial = fn_retjson(list)
					this.handle_createField(list)
					let c_obj = this.DetailsData
					// 产品信息列表
					if(c_obj.order_goods) {
						this.order_goods = c_obj.order_goods
						this.orderGoodSign = fn_retjson(c_obj.order_goods)
					}
					else if(c_obj.quotation_goods) {
						this.order_goods = c_obj.quotation_goods
						this.orderGoodSign = fn_retjson(c_obj.quotation_goods)
					}
					
					// 上传附件 
					this.enclist = this.fn_findSign('上传附件') || []
					this.assignment('上传附件', this.enclist)
					// 产品信息列表
					let group_id2 = this.findClassd('产品信息')
					if(group_id2) {  
						var arr1 = list.filter(v=>v.group_id == group_id2)
						var arr2 = arr1.filter(v=>v.is_lock == 1)
						this.ProductInfoField = arr2
					}
					
					// 回款信息列表
					let group_id3 = this.findClassd('回款信息')
					if(group_id3) {  
						var arr1 = list.filter(v=>v.group_id == group_id3)
						var arr2 = arr1.filter(v=>v.is_lock == 1)
						this.CollectionInfoField = arr2
					}
					
					setTimeout(()=>{
						if(this.is_return) {
							var link = document.createElement('a');
							link.href = '#returnid';
							link.click();
						}
					}, 600)
				})
			},
			
			fn_findSign(field_sign) {
				let res = '';
				if (this.order_info.length) {
					let index = this.order_info.findIndex(v => v.field_sign == field_sign)
					if (index != -1) {
						res = this.order_info[index].content
					} 
				}
				return res;
			},
			
			// 处理新建字段
			handle_createField(list) {
				// 基本信息
				let group_id1 = this.findClassd('基本信息')
				if(!group_id1) return;
				for (let item of list) { 
					fn_newfield(item)
					item.is_show = item.state ? true : false;
					let field = item.field || item.field_sign;
					// required: 1 必填
					let requArr = ['订单编号', '订单日期', '客户', '联系人', '负责人']
					item.required = requArr.some(v => v == field) ? 1 : 0;
					// 详情信息
					if (this.editfieldlist.length) {
						let curid = item.field_id || item.id;
						let res1 = fn_findeditid(curid, this.editfieldlist, this.field_initial)
						if (res1) {
							item.content = res1.content
							item.select_field = res1.select_field
						}
					}
					// 单个赋值 
					if (field == '订单编号') {
						item.field_type = 1
						if (this.DetailsData) {
							item.content = item.select_field = this.DetailsData.dd_code
						}
						else {
							item.content = item.select_field = this.returnCodes()
						}
					} 
					else if (field == '订单日期') {
						item.field_type = 3
						item.is_table = true
						if (this.DetailsData) {
							item.content = item.select_field = ToggleTime(this.DetailsData.order_time) || ''
						}
						else {
							item.content = Date.parse(new Date())
						}
					} else if (field == '订单备注') {
						item.field_type = 2
						item.maxLength = 250;
						item.column = true
					} 
					else if (field == "客户") {
						item.trends = true
						item.field_type = 12
						item.field_list = []
						if (this.DetailsData && this.DetailsData.customer) {
							// is_lock == 1 在公海
							let c_id = this.DetailsData.customer.is_lock == 1 ? this.DetailsData.customer.name1 :
								this.DetailsData.customer_id;
							let c_name = this.DetailsData.customer ? this.DetailsData.customer.name1 : '';
							item.select_field = c_name
							item.content = c_id
							item.singleval = {
								id: c_id,
								name: c_name,
							}
						}
					} else if (field == "联系人") {
						item.trends = true
						item.field_type = 5
						item.field_list = []
						if (this.DetailsData) {
							let c_name = this.DetailsData.contact ? this.DetailsData.contact.name1 : '';
							if (this.DetailsData.customer && this.DetailsData.customer.is_lock == 1) { // 在公海
								item.content = c_name
							} else {
								item.content = this.DetailsData.contact_id
							}
							item.select_field = c_name
						}
					}
					else if (field == "负责人") {
						item.field_type = 5
						item.field_list = this.memberlist
						if (this.DetailsData) {
							item.content = this.DetailsData.member_id
							item.select_field = this.DetailsData.member ? this.DetailsData.member.name : '';
						} else {
							item.content = localStorage.member_id * 1;
						}
					} else if (field == "协同人") {
						item.field_type = 6
						item.field_list = this.memberlist
						item.select_field = item.content = []
						if (this.DetailsData) {
							let assistant_arr1 = this.DetailsData.assistant_member_id ? this.DetailsData
								.assistant_member_id.split(',') : [];
							let assistant_arr2 = []
							for (let ass of assistant_arr1) {
								if (ass) {
									assistant_arr2.push(ass * 1)
								}
							}
							item.content = assistant_arr2
							if (this.memberlist.length && assistant_arr2.length) {
								let res_arr = []
								for (let val of assistant_arr1) {
									let arr1 = this.memberlist.filter(v => v.member_id == val)
									let name = arr1[0] ? arr1[0].name : '';
									if (name) {
										res_arr.push(name)
									}
								}
								item.select_field = res_arr.length ? res_arr.join('、') : '';
			
							} else {
								item.select_field = ''
							}
							
						}
					} 
					else if (field == "收货地址") {
						item.field_type = 18
						item.column = true
						if (this.DetailsData) {
							item.select_field = item.content = this.DetailsData.address ? this.DetailsData.address : JSON.parse(JSON.stringify(this.defaddress))
						}
					}
					else if (field == "订单状态") {
						item.field_type = 5
						item.field_list = this.OrderStatus
						if (this.DetailsData && this.DetailsData.status) {
							item.content = this.DetailsData.status_id 
							item.select_field = this.DetailsData.status.name || ''
						} else {
							item.content = this.OrderStatus[0] ? this.OrderStatus[0].id : '';
						}
					}
					// 
				}
				// 显示和编辑的字段列表
				let newList = list.filter(v=>v.group_id == group_id1)
				this.essentialInfo = fn_retjson(newList)
				this.dailyRecord = fn_retjson(newList)
				this.FieldInitial = fn_retjson(list)
			},
			//
			
			findClassd(name){
				let resGroup_id = ''
				let index = this.ClassInitial.findIndex(v=>v.name == name)
				if(index != -1 && this.ClassInitial[index]) {
					resGroup_id = this.ClassInitial[index].group_id
				}
				return resGroup_id
			},
			// 返回订单编码 DD+八位日期+六位随机
			returnCodes(){
				// 日期
				var date = new Date();
				var year = date.getFullYear() // 年
				var month = date.getMonth() + 1; // 月
				var day = date.getDate(); // 日
				var hour = date.getHours(); // 时
				let daynum = `${year}${month+1}${day}`
				// 6位随机数
				let mm = Math.random();
				let six = "";
				if (mm > 0.1) {
					six = Math.round(mm * 1000000);
				} else {
					mm += 0.1;
					six = Math.round(mm * 1000000);
				}
				return `DD${daynum}${six}`
			},
			
			
			
			
			
			
			
			
		},
		data() {
			return {
				glopertype: 0,
				
				editfieldlist: [],
				field_initial: [],
				dailyRecord: [],
				memberlist: [],
				// -------------------
			
				
				essenSignlist: [
					{
						field_sign: '订单编号',
						field_type: 1,
						required: true,
						content: '',
					},
					{
						field_sign: '订单日期',
						field_type: 3,
						required: true,
						content: Date.parse(new Date()),
					},
					{
						field_sign: '订单状态',
						field_type: 5,
						field_list: [],
						required: true,
						is_show: false,
						content: '',
					},
					{
						field_sign: '客户',
						field_type: 12,
						required: true,
						selectval: {
							id: '',
							name: "",
						},
						seltype: 1,
					},
					{
						field_sign: '收货地址',
						field_type: 18,
						column: true,
					},
					{
						field_sign: '联系人',
						field_type: 17,
						required: true,
						selectval: {
							id: '',
							name: "",
						},
						seltype: 2,
						screenid: '',
					},
					{
						field_sign: '负责人',
						field_type: 10,
						required: true,
						content: '',
					},
					{
						field_sign: '协同人',
						field_type: 11,
					},
					{
						field_sign: '订单备注',
						field_type: 2,
						maxLength: 150,
						column: true,
					},
				],
				
				
				defaddress: {
					area_txt1: '',
					area_txt2: '',
					area_txt3: '',
					area_id1: 0,
					area_id2: 0,
					area_id3: 0,
					address: '',
				},
				
				fileuplen: 0,
				flielen: 0,
				is_return: false,
				
				currentInput: '',
				satisfy_goods: '',
				satisfy_returnId: '',
				
				
				detail_title: '新建订单',
				isloading: true,
				
				isEdit: false,
				order_id: 0,
				is_recycle: 0,
				order_info: '',
				DetailsData:'',
				returnid: '',
				
				oninput: "value=value.replace(/[^0-9.]/g,'')",
				// 保存阀门
				serveFlag: true,
				clickflag: true,
				// 字段 ------------------
				// 订单状态
				OrderStatus: [],
				// 
			
				// 新建和编辑使用
				field_data: [],
				// 字段分类
				ClassInitial: [],
				// 字段列表
				// 所有字段信息
				FieldInitial: [],
				// 基本信息
				essentialInfo: [],
				// 产品信息字段
				ProductInfoField: [],
				// 回款信息字段
				CollectionInfoField: [],
				// 产品信息返回结果
				productExportInfo: '',
				// 回款信息返回结果
				collectInfo: '',
				// ------------------
				// 附件信息
				enclist: [],
				// 产品信息列表
				order_goods: [],
				orderGoodSign: [],
				
				goods_id: '',
				details_id: '',
				discount_amount: '',	 // 否	int	整单折扣额
				discount_rate: '',	 // 否	int	整单折扣率
				order_price: '0.00',
				
				
				
				
			}
		},
	}
</script>

<style lang="scss" scoped>
	.createpage{
		width: 100%;
		max-width: 2000px;
	}
	.receipts_box{
		width: 100%;
		padding: 0 35px;
		.receipts_item{
			.tit{
				font-size: 14px;
				font-weight: 400;
				color: rgba(56, 56, 56, 1);
				text-align: right;
				vertical-align: top;
				white-space: nowrap;
				margin-right: 5px;
			}
		}
	}  
	
	.detail_head{
		background-color: #fff;
		min-height: 58px;
		border-bottom:solid 1px rgba(235, 238, 245, 1);
		padding-right: 16px;
		position: sticky;
		top: 0px;
		z-index: 100;
		.head_left{
			.return_btn::after{
				content: '';
				position: absolute;
				right: 0;
				width: 1px;
				height: 16px;
				background: rgba(232, 232, 232, 1);
			}
			.return_btn{
				cursor: pointer;
				position: relative;
				width: 97px;
				span{
					margin-left: 10px;
					font-size: 14px;
					font-weight: 400;
					color: rgba(0, 0, 0, 1);
					text-align: left;
					vertical-align: top;
				}
				
			}
			.title{
				margin-left: 20px;
				font-size: 16px;
				font-weight: 400;
				color: rgba(56, 56, 56, 1);
				text-align: left;
				vertical-align: top;
			}
		}
		
	}
	
	.detail_templates:last-of-type{
		margin-bottom: 0;
	}
	.detail_templates{
		width: 100%;
		min-width: 960px;
		background-color: #fff;
		padding: 16px 19px 25px 19px;
		margin-bottom: 10px;
		.detail_intitle::before{
			content: '';
			position: absolute;
			left: 0;
			height: 100%;
			width: 2px;
			background: rgba(43, 117, 235, 1);
		}
		.detail_intitle{
			margin-bottom: 20px;
			padding: 0 18px;
			position: relative;
			width: 100%;
			min-height: 34px;
			background: rgba(249, 249, 249, 1);
			
			font-size: 14px;
			font-weight: 550;
			color: rgba(38, 38, 38, 1);
			text-align: left;
			vertical-align: top;
		}
	}
	 
</style>